/* *************************************************************** *
 * THIS IS AN AUTO GENERATED FILE. PLEASE DO NOT EDIT IT DIRECTLY.
 *
 * If you want to change this Icon component , it is generated
 * from the `iconTamplate.js` file the parent directory.
 * *************************************************************** */
/* eslint-disable */
import React from 'react';
import { useFela, } from 'react-fela';
import iconStyle from '../iconStyle';
import { iconPropTypes, iconDefaultProps, } from '../iconPropTypes';

export default function IconBack({ size, fill, color, attrs, miscStyles, ...props }) {
  const className = useFela({ size, fill, color, miscStyles, }).css(iconStyle);

  return (
    <svg width="0.8828125em" height="1em" viewBox="0 0 226 256" className={className} {...props} {...attrs} data-test="IconBack">  <path fill="currentColor" d="M138.4 226.4l-77.8-77.8-19.1-19.1 19.1-19.1 77.8-77.8 19.1 19.1-77.8 77.8 77.8 77.8-19.1 19.1z" /></svg>
  );
}

IconBack.propTypes = iconPropTypes;
IconBack.defaultProps = iconDefaultProps;